import {Component, OnInit} from '@angular/core';
import {SelectComponent} from 'web-shared';
import {CostPriceComponentQuery} from 'web-shared';
import {ControlContainer, NgForm} from '@angular/forms';
import {CostPriceComponentEditModalComponent} from '../cost-price-component-edit-modal/cost-price-component-edit-modal.component';

@Component({
  selector: 'mes-cost-price-component-select',
  templateUrl: './cost-price-component-select.component.html',
  styles: [],
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class CostPriceComponentSelectComponent extends SelectComponent<CostPriceComponentQuery> implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
  }

  addNew(searchTerm?: string) {
    const data = {initialState: {code: searchTerm}};
    this.startEdit(data);
  }

  edit() {
    const data = {initialState: {entityId: this.entityId}};
    this.startEdit(data);
  }

  startEdit(data) {
    this.modalService
      .show(CostPriceComponentEditModalComponent, data).content.onHide$
      .subscribe(({data}) => this.setEntityId(data));
  }
}
